module.exports = __webpack_public_path__ + "fonts/icomoon.d737e7ef.eot";